import { Star, Quote } from "lucide-react";
import {
  Carousel,
  CarouselContent,
  CarouselItem,
  CarouselPrevious,
  CarouselNext,
} from "@/components/ui/carousel";

const testimonials = [
  {
    name: "Anna K.",
    text: "Świetny występ! Nasi pracownicy byli zachwyceni, a pozytywna energia utrzymywała się jeszcze przez wiele dni.",
  },
  {
    name: "Marek N.",
    text: "Profesjonalne podejście i świetne dostosowanie żartów do naszej branży. Polecam!",
  },
  {
    name: "Katarzyna W.",
    text: "Najlepsza impreza firmowa, jaką kiedykolwiek organizowaliśmy. Goście do dziś wspominają ten wieczór!",
  },
  {
    name: "Tomasz L.",
    text: "Rewelacyjny kontakt z publicznością i niesamowita energia. Na pewno zaprosimy ponownie.",
  },
  {
    name: "Joanna M.",
    text: "Idealnie trafiony humor, dopasowany do naszego zespołu. Wszyscy świetnie się bawili!",
  },
  {
    name: "Piotr S.",
    text: "Bardzo profesjonalna obsługa od pierwszego kontaktu. Występ przeszedł nasze najśmielsze oczekiwania.",
  },
  {
    name: "Ewa D.",
    text: "Fantastyczna atmosfera i mnóstwo śmiechu. To był strzał w dziesiątkę na naszą galę!",
  },
  {
    name: "Robert B.",
    text: "Polecam każdemu, kto szuka czegoś wyjątkowego na event firmowy. Poziom światowy!",
  },
];

export const Testimonials = () => {
  return (
    <section className="py-24 section-dark relative overflow-hidden">
      <div className="absolute inset-0 mesh-gradient opacity-40" />
      <div className="container relative z-10">
        <h2 className="text-4xl md:text-5xl font-space-grotesk font-bold text-center mb-4 text-foreground">
          Co mówią <span className="text-gradient">Klienci?</span>
        </h2>
        <p className="text-muted-foreground text-center mb-16 max-w-md mx-auto">
          Opinie zadowolonych klientów
        </p>
        <div className="max-w-5xl mx-auto px-12">
          <Carousel opts={{ align: "start", loop: true }}>
            <CarouselContent className="-ml-4">
              {testimonials.map((testimonial) => (
                <CarouselItem key={testimonial.name} className="pl-4 md:basis-1/2 lg:basis-1/3">
                  <div className="glass-strong rounded-2xl p-8 relative h-full flex flex-col min-h-[250px]">
                    <Quote className="w-8 h-8 text-primary/20 absolute top-6 right-6" />
                    <div className="flex gap-1 mb-4">
                      {[1, 2, 3, 4, 5].map((i) => (
                        <Star key={i} className="w-4 h-4 text-accent" fill="currentColor" />
                      ))}
                    </div>
                    <p className="text-foreground mb-6 leading-relaxed flex-grow">{testimonial.text}</p>
                    <div className="flex items-center gap-3 mt-auto">
                      <div className="w-10 h-10 rounded-full bg-primary/20 flex items-center justify-center text-primary font-bold text-sm">
                        {testimonial.name.charAt(0)}
                      </div>
                      <p className="font-space-grotesk font-bold text-foreground text-sm">{testimonial.name}</p>
                    </div>
                  </div>
                </CarouselItem>
              ))}
            </CarouselContent>
            <CarouselPrevious />
            <CarouselNext />
          </Carousel>
        </div>
      </div>
    </section>
  );
};
